import * as React from 'react'
import { PageHeader } from '@pushly/aqe/lib/components'
import { classnames } from '@halo/_utils/classnames'
import { observer } from 'mobx-react'
import { DomainList } from '@halo/components/domain-list/domain-list'
import { noop } from '@pushly/aqe/lib/utils/noop'

export const DOMAINS_ROUTE = '/domains'

@observer
export class Domains extends React.Component<any, any> {
    public render() {
        return (
            <div className={classnames('page', 'domains')}>
                <div className={classnames('page-wrapper')}>
                    <PageHeader title="Domains" onTitleSet={noop} />

                    <DomainList options={{}} />
                </div>
            </div>
        )
    }
}
